<script setup lang="ts">
import { capitalize } from "vue";
const { t } = useI18n();

interface Advantage {
	icon: string;
	title: string;
	description: string;
}

const advantages: ComputedRef<Advantage[]> = computed(() => [{
	icon: "solar:calendar-outline",
	title: t("productionTime"),
	description: capitalize(t("productionTimeDescription"))
},
{
	icon: "solar:clock-circle-outline",
	title: t("convenientCheckout"),
	description: capitalize(t("convenientCheckoutDescription"))
},
{
	icon: "solar:box-outline",
	title: t("deliveryAcrossUkraine"),
	description: capitalize(t("deliveryAcrossUkraineDescription"))
}]);
</script>

<template>
	<section class="box-content px-4 flex gap-10 justify-between items-center xs:flex-col">
		<div v-for="{ icon, title, description } in advantages" :key="title" class="flex gap-x-4 gap-y-5 sm:flex-col xs:flex-col xs:items-center">
			<Icon :name="icon" size="48" class="text-green-dark" />
			<div class="flex flex-col xs:gap-y-2 xs:items-center xs:text-center">
				<span class="uppercase font-medium xs:text-xl">
					{{ title }}
				</span>
				<span class="text-green-dark text-base xs:max-w-[256px]">
					{{ description }}
				</span>
			</div>
		</div>
	</section>
</template>
